import React from 'react';
import { components } from '@kurtosys/ksys-app-components';

import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';
import { megaMenuStyle } from '../styles/MegaMenu.styles.js';

type IButtonProps = components.base.Button.models.IButtonProps;

const Button = components.base.Button.Button;
const StyledComponent = InjectedStyledComponent(
	Button,
	'megaMenu',
	['clearAllButton'],
	undefined,
	undefined,
	undefined,
	megaMenuStyle,
);
export default React.forwardRef<HTMLButtonElement, IButtonProps>((props, ref) => (
	<StyledComponent {...props} forwardedRef={ref} />
));
